<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">

        <v-btn
          v-if="!pickedPerson"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="fetchAllData">
          Vyhľadať upratovača
        </v-btn>

         <v-btn
          v-else
          color="#007520"
          dark
          v-bind="attrs"
          v-on="on"
          @click="fetchAllData">
          Zmeniť upratovača/termín
          <v-icon
            dark
            right>
            mdi-checkbox-marked-circle
          </v-icon>
        </v-btn>

      </template>
      <v-card>
        <v-toolbar 
          ref="toolBar"
          dark
          color="accent">
          <v-toolbar-title>Prehľad upratovačov</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-btn
            icon
            dark
            @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          
        </v-toolbar>

        <v-divider/>

        <v-container v-if="dataReceived" class="pb-10">
          <v-row class="d-flex">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="4"
              xl="3"
              class="mt-10 flex-grow-1 d-flex"
              v-for="person in persons"
              :key="person.id"
            >
              <person-profile 
                :person="person"
                :time="time" 
                @order="order"/>
            </v-col>
          </v-row>
        </v-container>


        <v-card v-if="!dataReceived" :height="winHeight">
            <v-container fill-height>
              <v-row 
                justify="center"
                align="center"
                >
                <v-progress-circular
                  :size="70"
                  color="accent"
                  indeterminate
                />
              </v-row>
          </v-container>
        </v-card>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import PersonProfile from './PersonProfile.vue'
import axios from "axios";

  export default {
    components: {PersonProfile },
    name: "ChoosePerson",
    props: [
      'time',
    ],
    data () {
      return {
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
        personId: null,
        pickedPerson: false,
        toolBarHeight: 0,
        dataReceived: false,
        persons: []
      }
    },
    methods: {
      closeDialog() {
        this.dialog = false;
      },
      order(person) {
        this.dialog = false;
        this.pickedPerson = true;
        this.$emit('order', person);
      },
      fetchAllData(){
        this.dataReceived = false;
        axios.get('http://www.st.fmph.uniba.sk/~torma6/phpserver/get-profiles.php')
            .then((response) => {
              this.persons = response.data;
              this.dataReceived = true;
              this.$emit('dataReceived');
            })
      },
    },
    computed: {
      winHeight(){
        return window.innerHeight - this.toolBarHeight - 1;
      }
    },
    updated(){
      if(this.$refs.toolBar) this.toolBarHeight = this.$refs.toolBar.computedHeight;
    },
    // created(){
    //   this.fetchAllData();
    // },
  }
</script>
